module.exports = __webpack_public_path__ + "9650fcf1e33c60c4b818f94caf093bfc.fbx";